import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { topekaConfig } from "./data";

export default function TopekaPage() {
  return <CityPageTemplate config={topekaConfig} />;
}